import { render, staticRenderFns } from "./test-center.vue?vue&type=template&id=b51a3a22&scoped=true"
import script from "./test-center.vue?vue&type=script&lang=js"
export * from "./test-center.vue?vue&type=script&lang=js"
import style0 from "./test-center.vue?vue&type=style&index=0&id=b51a3a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51a3a22",
  null
  
)

export default component.exports